module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "upper-subpanel--inside"
  }, [(_vm.getComboMed === false) ? _c('Loader') : _c('div', {
    staticClass: "combomed-list-wrapper"
  }, [_c('div', {
    staticClass: "med-list"
  }, [(_vm.comboMedSet.length === 0) ? _c('div', {
    staticStyle: {
      "display": "flex",
      "justify-content": "center",
      "align-items": "center",
      "height": "100%"
    }
  }, [_c('h5', [_vm._v("未設定藥物組合")])]) : _c('div', [_vm._l((_vm.comboMedSet), function(med, index) {
    return _c('div', {
      staticClass: "combomed-button",
      class: {
        'combomed-button-selected': med.selected, 'unselectable': med.amountInSystem === 0, 'fetched-button': med.fetched
      }
    }, [_c('div', {
      staticClass: "combomed-detail",
      on: {
        "click": function($event) {
          return _vm.selectMed(med)
        }
      }
    }, [_c('div', {
      class: {
        'fetched': med.fetched
      },
      attrs: {
        "id": "fetch_status"
      }
    }, [_vm._v(_vm._s(_vm._f("fetchZh")(med.fetched)))]), _c('div', {
      attrs: {
        "id": "med_info"
      }
    }, [_c('h6', [_vm._v(_vm._s(med.child_medication.code) + " - " + _vm._s(med.child_medication.CGMH_number))]), _c('span', [_c('small', [_vm._v(_vm._s(med.child_medication.generic_name) + " ")]), (med.child_medication.product_name) ? _c('small', [_vm._v(_vm._s(med.child_medication.product_name))]) : _vm._e()])]), _c('div', [(med.parent_medication.type === 'combo') ? _c('p', {
      attrs: {
        "id": "combo-name"
      }
    }, [_c('span', [_vm._v("套藥")]), _c('span', [_vm._v(_vm._s(med.parent_medication.generic_name))])]) : _vm._e(), _c('p', {
      attrs: {
        "id": "remain_amount"
      }
    }, [_c('span', [_vm._v("系統存量")]), _c('span', [_vm._v(_vm._s(med.amountInSystem))])]), (med.child_medication_dose) ? _c('p', {
      attrs: {
        "id": "dose"
      }
    }, [_c('span', [_vm._v("用藥劑量")]), _c('span', [_vm._v(_vm._s(med.child_medication_dose)), (med.child_medication_dose_unit) ? _c('span', [_vm._v(_vm._s(med.child_medication_dose_unit) + " ")]) : _vm._e()])]) : _vm._e(), (med.child_medication_quantity) ? _c('p', {
      attrs: {
        "id": "dose"
      }
    }, [_c('span', [_vm._v("取藥數量")]), _c('span', [_vm._v(_vm._s(med.child_medication_quantity) + " "), (med.child_medication_quantity_unit) ? _c('span', [_vm._v(_vm._s(med.child_medication_quantity_unit))]) : _vm._e()])]) : _vm._e()])])])
  }), (_vm.otherFetchEvents.length > 0) ? _c('div', _vm._l((_vm.otherFetchEvents), function(event) {
    return _c('div', {
      staticClass: "combomed-button other-fetch-events"
    }, [_c('div', {
      staticClass: "combomed-detail"
    }, [(event.related_events.length === 0) ? _c('div', {
      staticStyle: {
        "background-color": "green",
        "color": "white"
      },
      attrs: {
        "id": "fetch_status"
      }
    }, [_vm._v("已取藥")]) : _c('div', {
      staticStyle: {
        "background-color": "red",
        "color": "white"
      },
      attrs: {
        "id": "fetch_status"
      }
    }, _vm._l((event.related_events), function(e) {
      return _c('div', [_vm._v(_vm._s(_vm._f("zhLabel")(e.event_type.event_name)))])
    }), 0), _c('div', {
      attrs: {
        "id": "med_info"
      }
    }, [_c('h6', [_vm._v(_vm._s(event.medication.code) + " - " + _vm._s(event.medication.CGMH_number))]), _c('span', [_c('small', [_vm._v(_vm._s(event.medication_generic_name))])])]), _c('div', [_c('p', {
      attrs: {
        "id": "dose"
      }
    }, [_c('span', [_vm._v("數量")]), _c('span', [_vm._v(_vm._s(Math.abs(event.number1)))])])])])])
  }), 0) : _vm._e()], 2)])]), _c('div', {
    staticClass: "fake-bottom-buttons"
  }, [_c('action-button', {
    attrs: {
      "title": "選擇全部"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.selectAllMed(true)
      }
    }
  }), _c('action-button', {
    attrs: {
      "title": "取消選擇"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.selectAllMed(false)
      }
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3ad6c0e4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/flowComp/ComboMedListAndPatient.vue
// module id = 1440
// module chunks = 1